
import BytecookieLogo from '@/components/svg/logo/logo-customer-landingpage.svg?inline';
import {
  computed, defineComponent, inject, ref
} from 'vue';
import LPCustomerStep from '@/views/public/landingpage/components/LPCustomerStep.vue';
import useI18n from '@/mixins/useI18n';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import { useMediaQuery } from '@vueuse/core';
import LPBGArrow from '@/views/public/landingpage/components/LPBgArrow.vue';
import LPButton from '@/views/public/landingpage/components/LPButton.vue';
import useMultiLineBreaks from '@/mixins/useMultiLineBreaks';
import LPExplainVideo from '@/views/public/landingpage/components/LPExplainVideo.vue';
import LPUserCarousel from '@/views/public/landingpage/components/user-carousel/LPUserCarousel.vue';
import LPAccordion from './components/LPAccordion.vue';

export default defineComponent({
  name: 'LandingpageCustomer',
  components: {
    LPExplainVideo,
    LPUserCarousel,
    LPButton,
    LPBGArrow,
    BCXMarkdown,
    BytecookieLogo,
    LPCustomerStep,
    LPAccordion
  },
  setup() {
    const { t } = useI18n();
    const isMobile = useMediaQuery('(width < 800px)');
    const isUserCarouselVisible = ref(false);
    const steps = computed(() => t('landingpage-customer.steps'));
    const toggleInvitePopup = inject<CallableFunction>('toggleInviteCodePopup');
    const isSmartphone = useMediaQuery('(max-width: 799px)');

    // eslint-disable-next-line no-nested-ternary
    const lineBreak = computed(() => (isMobile.value ? 'narrow' : 'wide'));
    const linebreaks = t('landingpage-customer.linebreaks') as any;
    const { tl } = useMultiLineBreaks(linebreaks, lineBreak);

    return {
      isUserCarouselVisible,
      steps,
      isMobile,
      toggleInvitePopup,
      isSmartphone,
      tl
    };
  }
});

